import React, {useEffect, useState} from 'react'
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import SuccessModal from "../../../CustomModal/Success";
import {toast} from "react-toastify";
import DashboardMenu from "../../../layout/dashboardMenu";

const RejectBAVActivity = ({
                            match,
                            history,
                            rejectActivity,
                            rejectActivityDetails=[],
                            activityByIdDetails=[],
                            viewActivity,
                         }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const islatlng = useLatLng();
    const [isAllow, setIsAllow] = useState(false);
    const [inputList, setInputList] = useState([{
        next_activity_id: '',
        next_activity_date: '',
        lat: '',
        long: '',
        description:'',
        meta_data:{}
    }])
    const [successMessage, setSuccessMessage] = useState('')
    const [accountId, setAccountId] = useState('')
    const [openCheckIn, setOpenCheckIn] = useState(false)

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await viewActivity(match?.params?.id)
            setIsLoading(false)
        })()
    }, [])

    useEffect(() => {
        if(activityByIdDetails?.data?.account_id !== undefined){
            setAccountId(activityByIdDetails?.data?.account_id)
        }
    }, [activityByIdDetails])

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    const handleInput = (key, val, metaKey = '', e = '') => {
        let list = [...inputList]
        if (key === 'meta_data') {
            if (e.target !== undefined && e.target.selectedOptions !== undefined) {
                inputList[0][key][metaKey] = e.target.selectedOptions[0].text
                inputList[0][key][metaKey + "_id"] = val
            } else {
                inputList[0][key][metaKey] = val
            }
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }


    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (rejectActivityDetails?.status === 200) {
            setIsSuccessModalOpen(true)
            setSuccessMessage(rejectActivityDetails?.message)
            // setOpenCheckIn(true)
        } else if (rejectActivityDetails?.status !== undefined && rejectActivityDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setSuccessMessage(rejectActivityDetails?.message)
        }
    }, [rejectActivityDetails])


    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        list['id'] = match?.params?.id
        list['account_id'] = accountId
        list['lat'] = islatlng?.lat
        list['long'] = islatlng?.lng
        if (list['long'] == null || list['lat'] == null) {
            toast.error('Please enable your location');
            return false
        }
        setIsLoading(true)
        await rejectActivity(list)
        setIsLoading(false)
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={successMessage}
                url={`ba-activity-list/${match?.params?.lead_id}`}
            />

            <FailedModal
                isOpen={isFailedModalOpen}
                msg={successMessage}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Activity"}
                            history={history}
                        />
                        {/*BODY*/}
                        <div className="container-fluid common-bg">
                            <form onSubmit={(e) => handleSubmit(e)}>

                                <div className="row">
                                    <div className="col-md-12">
                                        <div
                                            className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                            <h1 className="h3 mb-0 text-black-100">
                                                <b>{activityByIdDetails?.data?.activity_name}</b>
                                            </h1>
                                        </div>
                                        <div className="card-body bg-white">
                                            <div className="user">
                                                <div className="form-group row">
                                                    <div className="col-sm-6 mt-1 float-field">
                                                                <textarea
                                                                    className="form-control form-control-user cus-red"
                                                                    placeholder="Remark*"
                                                                    onChange={(e) => {
                                                                        handleInput('meta_data', e.target.value, 'remark', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                        <label className="large-label float-lb">
                                                            {/*Remark*/}
                                                        </label>
                                                    </div>
                                                    <hr/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-4 d-flex" >
                                    <button className="btn btn-primary btn-user btn-block submit-btn" style={{backgroundColor:"#d94d40"}}>
                                        Reject
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default RejectBAVActivity